module.exports = __webpack_public_path__ + "guanao-pc/static/media/wx.4528b845.jpg";